import { render, staticRenderFns } from "./MergeSchoolsButton.vue?vue&type=template&id=02577f63"
import script from "./MergeSchoolsButton.vue?vue&type=script&lang=js"
export * from "./MergeSchoolsButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports